import { useEffect } from "react";

import {
    PreloadedQuery,
    useLazyLoadQuery,
    usePreloadedQuery
} from "react-relay";

import { ProductKeys } from "@atlassiansox/asc-stargate";

import { agileOverviewOneQuery } from "@/__generated_contentful__/agileOverviewOneQuery.graphql";
import { agileOverviewTwoQuery } from "@/__generated_contentful__/agileOverviewTwoQuery.graphql";
import { SiteSelectorContextProvider } from "@/components/site-selector-modal";
import { SitesContextProvider } from "@/components/sites-provider";
import {
    AgileOverviewQueryData,
    AgileOverviewOneQuery,
    AgileOverviewTwoQuery,
    getAgileOverviewQueryVars,
    shapeAgileOverviewContentfulResponse
} from "@/contentful/graphql/agile-overview";
import { AgileOverviewPageTemplate } from "@/templates/agile-hub/src/agile-overview-page.template";
import { AgileOverviewProvider } from "@/templates/agile-hub/src/agile-overview.provider";
import { AgileOverview } from "@/templates/agile-hub/types";
import { checkFeatureFlagGate } from "@/utils/feature-flags/check-feature-flag.ts";
import { featureFlags } from "@/utils/feature-flags/feature-flag-manifest.ts";

export type AgileOverviewPageProps = {
    agileOverview: AgileOverview | null;
    queryRef: PreloadedQuery<agileOverviewOneQuery>;
    location: Location;
};

export const AgileOverviewPage = ({
    agileOverview,
    queryRef,
    location
}: AgileOverviewPageProps) => {
    const dataPartOne = usePreloadedQuery<agileOverviewOneQuery>(
        AgileOverviewOneQuery,
        queryRef
    );
    const dataPartTwo = useLazyLoadQuery<agileOverviewTwoQuery>(
        AgileOverviewTwoQuery,
        getAgileOverviewQueryVars(location)
    );

    const combinedData = {
        micrositeTopicOverviewCollection: {
            items: [
                {
                    ...dataPartOne.micrositeTopicOverviewCollection?.items[0],
                    ...dataPartTwo.micrositeTopicOverviewCollection?.items[0]
                }
            ]
        }
    } as AgileOverviewQueryData;

    agileOverview = shapeAgileOverviewContentfulResponse(combinedData);

    return (
        <SitesContextProvider>
            <SiteSelectorContextProvider
                analyticsPrefix="jira-software.ondemand" // TODO: Check if this is correct
                productKey={ProductKeys.JIRA_SOFTWARE}
            >
                <AgileOverviewProvider agileOverview={agileOverview}>
                    <AgileOverviewPageTemplate />
                </AgileOverviewProvider>
            </SiteSelectorContextProvider>
        </SitesContextProvider>
    );
};
